/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useMemo, useState } from 'react';
import { View } from 'react-native';

import { isWeb } from '@global/screens';
import Colors from '@global/colors';

import TitleSubSection from '@components/global/TitleSubSection';
import ItemDetail from '@components/global/ItemDetail';
import Image from '@components/global/Image';
import Input from '@components/form/Input';
import Button from '@components/form/Button';
//import CustomerClusterSearch from '@components/form/search/CustomerClusterSearch';
import SociollaText from '@components/sociolla/SociollaText';
import SociollaTabs from '@components/sociolla/SociollaTabs';
import Address from '@components/customer/register/Address';

import { MsOrder } from '@api/ms-order';

const defaultPhoto = require('@/assets/img/default/user-default.png');

const TargetCustomer = ({
  detailCustomer = {},
  detailCustomerCluster = {},
  payloadCluster = { average_purchase_amount: '', cluster: '' },
  onChangePayload = () => {},
}) => {
  const [loadingCalculation, setLoadingCalculation] = useState(false);
  const [tabActive, setTabActive] = useState('details');
  const createdBy = useMemo(() => {
    const user = { name: '', image: '' };
    if (detailCustomer.state_histories?.length) {
      if (
        detailCustomer.state_histories[
          detailCustomer.state_histories.length - 1
        ].status_changed_by?.name
      ) {
        user.name =
          detailCustomer.state_histories[
            detailCustomer.state_histories.length - 1
          ].status_changed_by.name;
        user.image = detailCustomer.created_by.image;
      } else {
        user.name = detailCustomer.created_by.name;
        user.image = detailCustomer.created_by.image;
      }
    }
    return user;
  }, [detailCustomer]);

  const runCalculation = async () => {
    setLoadingCalculation(true);
    try {
      const today = new Date();
      const response = await MsOrder.getSalesOrder({
        params: {
          filter: {
            'customer.id': detailCustomer?._id,
            order_date: {
              $lte: today.toISOString(),
              $gte: new Date(
                today.getFullYear(),
                today.getMonth() - 5,
                today.getDate(),
              ).toISOString(),
            },
          },
        },
      });
      if (response?.data?.data?.length) {
        const result = response.data.data;
        let total = 0;
        for (let i = 0; i < result.length; i++) {
          const item = result[i];
          if (item?.total_amount && !isNaN(Number(item.total_amount))) {
            total += Number(item.total_amount);
          }
        }
        onChangePayload({
          ...payloadCluster,
          average_purchase_amount: total.toString(),
        });
        setLoadingCalculation(false);
      } else {
        onChangePayload({ ...payloadCluster, average_purchase_amount: '0' });
        setLoadingCalculation(false);
      }
    } catch (error) {
      onChangePayload({ ...payloadCluster, average_purchase_amount: '0' });
      setLoadingCalculation(false);
    }
  };

  return (
    <View style={{ width: '100%' }}>
      <View style={{ width: '100%', paddingHorizontal: 20 }}>
        <ItemDetail
          centered
          name="Submmited By"
          value={
            createdBy && createdBy.name ? (
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <View
                  style={{
                    width: 20,
                    height: 20,
                    overflow: 'hidden',
                    borderRadius: 20,
                    marginRight: 8,
                  }}>
                  <Image
                    source={
                      createdBy.image ? { uri: createdBy.image } : defaultPhoto
                    }
                    style={{ width: 20, height: 20 }}
                    width={20}
                    height={20}
                    defaultSource={defaultPhoto}
                    isPhoto={true}
                  />
                </View>
                <SociollaText style={{ fontSize: 12 }}>
                  {createdBy.name}
                </SociollaText>
              </View>
            ) : (
              '-'
            )
          }
          withoutBorder
        />
      </View>
      <SociollaTabs
        style={[
          isWeb
            ? { marginTop: 20 }
            : {
                borderTopWidth: 1,
                borderTopColor: Colors.grey9,
                paddingTop: 5,
              },
          { marginHorizontal: -20 },
        ]}
        data={[
          {
            label: 'Details',
            value: 'details',
          },
          {
            label: 'Address',
            value: 'address',
          },
          {
            label: 'Sales Info',
            value: 'sales',
          },
        ]}
        tabActive={tabActive}
        setTabActive={(val) => setTabActive(val)}
      />
      {tabActive === 'details' && (
        <>
          <TitleSubSection title="COMPANY INFO"></TitleSubSection>
          <View
            style={{
              width: '100%',
              flexDirection: isWeb ? 'row' : 'column',
              justifyContent: 'space-between',
              paddingHorizontal: 20,
              paddingBottom: 30,
            }}>
            <View style={{ width: isWeb ? '48%' : '100%' }}>
              <ItemDetail
                name="Street"
                value={detailCustomer.street ? detailCustomer.street : '-'}
              />
              <ItemDetail
                name="Street 2"
                value={detailCustomer.street2 ? detailCustomer.street2 : '-'}
              />
              <ItemDetail
                name="Country"
                value={
                  detailCustomer.country && detailCustomer.country.name
                    ? detailCustomer.country.name
                    : '-'
                }
              />
              <ItemDetail
                name="State"
                value={
                  detailCustomer.state && detailCustomer.state.name
                    ? detailCustomer.state.name
                    : '-'
                }
              />
              <ItemDetail
                name="City"
                value={
                  detailCustomer.city && detailCustomer.city.name
                    ? detailCustomer.city.name
                    : '-'
                }
              />
              <ItemDetail
                name="ZIP Code"
                value={
                  detailCustomer.postal_code ? detailCustomer.postal_code : '-'
                }
              />
            </View>
            <View style={{ width: isWeb ? '48%' : '100%' }}>
              <ItemDetail
                name="NPWP"
                value={detailCustomer.vat ? detailCustomer.vat : '-'}
              />
              <ItemDetail
                name="Phone"
                value={detailCustomer.phone ? detailCustomer.phone : '-'}
              />
              <ItemDetail
                name="Mobile"
                value={detailCustomer.mobile ? detailCustomer.mobile : '-'}
              />
            </View>
          </View>
        </>
      )}
      {tabActive === 'address' && (
        <View
          style={{
            justifyContent: 'flex-start',
            paddingHorizontal: 20,
            paddingBottom: 30,
          }}>
          <Address
            delivery={detailCustomer.delivery_address}
            invoice={detailCustomer.invoice_address || []}
            hideDelete={true}
          />
        </View>
      )}
      {tabActive === 'sales' && (
        <View
          style={{
            flexDirection: (detailCustomerCluster?._id ? !isWeb : isWeb)
              ? 'column'
              : 'row',
            paddingVertical: 20,
            justifyContent: 'flex-start',
            paddingHorizontal: 20,
            paddingBottom: 30,
          }}>
          <View
            style={{
              width: isWeb && detailCustomerCluster?._id ? '50%' : '100%',
              paddingRight: isWeb ? 20 : 0,
            }}>
            <ItemDetail
              name="Market Type"
              value={detailCustomer.market_type?.code || '-'}
            />
            <ItemDetail
              name="Business Type"
              value={detailCustomer.market_type?.business_type?.code || '-'}
            />
            <ItemDetail
              name="Sales Person"
              value={detailCustomer.user?.name || '-'}
            />
            <ItemDetail
              name="Special Expired Date"
              value={
                detailCustomer.special_expired_period
                  ? detailCustomer.special_expired_period.split('_')[0] +
                    ' Months'
                  : '-'
              }
            />
            <ItemDetail
              name="Payment Terms"
              value={detailCustomer.payment_terms?.name || '-'}
            />
            <ItemDetail
              name="Limit Amount"
              value={detailCustomer.limit_amount || '-'}
            />
            <ItemDetail
              name="Loyalty Point"
              value={detailCustomer.loyalty_points?.count || '-'}
            />
          </View>
          {detailCustomerCluster?._id ? (
            <View
              style={{
                width: isWeb ? '50%' : '100%',
                paddingLeft: isWeb ? 20 : 0,
              }}>
              <ItemDetail
                name="Average Total Purchases"
                valueComponent={
                  <View style={{ flex: 1 }}>
                    <Input
                      label=""
                      value={payloadCluster.average_purchase_amount}
                      isNumeric
                      keyboardType="numeric"
                      editable={false}
                      onChangeText={(value) => {
                        onChangePayload({
                          ...payloadCluster,
                          average_purchase_amount: value,
                        });
                      }}
                    />
                    {detailCustomerCluster?.status == 'need_approval' ? (
                      <Button
                        rounded={true}
                        buttonStyle={{ width: '100%', marginTop: 5 }}
                        disabledStyle={{ width: '100%', marginTop: 5 }}
                        disabled={loadingCalculation}
                        title={
                          <SociollaText
                            type="bold"
                            style={{
                              fontSize: 14,
                              letterSpacing: 0.5,
                              color: Colors.white,
                            }}>
                            Run Calculation
                          </SociollaText>
                        }
                        onPress={() => runCalculation()}
                      />
                    ) : (
                      false
                    )}
                  </View>
                }
              />
              <ItemDetail
                name="Cluster"
                value={payloadCluster?.cluster?.name || '-'}
              />
              {/* <ItemDetail
                name="Cluster"
                valueComponent={
                  <View style={{ flex: 1 }}>
                    <CustomerClusterSearch
                      hideLabel={true}
                      value={payloadCluster.cluster}
                      disabled={
                        loadingCalculation ||
                        detailCustomerCluster?.status != 'need_approval'
                      }
                      customFilter={{
                        is_active: true,
                      }}
                      onChange={(value) => {
                        onChangePayload({ ...payloadCluster, cluster: value });
                      }}
                    />
                  </View>
                }
              /> */}
            </View>
          ) : (
            false
          )}
        </View>
      )}
    </View>
  );
};

export default TargetCustomer;
